import { createContext } from 'react'
import type { NodeFileUploadHost } from './file-upload-host'

export const NodeFileUploadContext = createContext<NodeFileUploadHost | null>(null)
